/**
 * Pause the ambient gradient motion when it's offscreen.
 *
 * The `--animated` gradient overlays (_gradient-overlay.css) animate `@property`
 * angle/stop offsets that recompute a `linear-gradient` every frame — paint work
 * that is NOT GPU-compositable, and it runs `infinite` even when the section has
 * scrolled out of view. An IntersectionObserver toggles `animation-play-state`
 * (via `.is-offscreen`) so only the overlay(s) currently in the viewport paint —
 * at most one section's gradient animates at a time. A pure battery/paint win;
 * the visible result is identical.
 *
 * Degrades safely: no JS → overlays animate as before (never broken). Reduced-
 * motion users already have `animation: none` (the primitive's media guard), so
 * the play-state toggle is a no-op for them.
 */

const overlays = document.querySelectorAll( '.c-gradient-overlay--animated' );

if ( overlays.length && 'IntersectionObserver' in window ) {
	const observer = new IntersectionObserver(
		( entries ) => {
			for ( const entry of entries ) {
				entry.target.classList.toggle( 'is-offscreen', ! entry.isIntersecting );
			}
		},
		{ rootMargin: '0px' }
	);

	for ( const overlay of overlays ) {
		observer.observe( overlay );
	}
}
